import { NavLink, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Forklift, Languages, LogOut } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 text-sm rounded-lg whitespace-nowrap transition-colors ${
    isActive
      ? 'bg-primary-50 text-primary-700 font-medium'
      : 'text-gray-600 hover:bg-gray-100'
  }`

// ナビは PC ではタイトル横、スマホでは2段目に表示する（重複定義を避けるため共通化）
function NavLinks() {
  const { t } = useTranslation()
  return (
    <>
      <NavLink to="/" end className={navLinkClass}>
        {t('nav.machines')}
      </NavLink>
      <NavLink to="/components" className={navLinkClass}>
        {t('nav.components')}
      </NavLink>
      <NavLink to="/lots" className={navLinkClass}>
        {t('nav.lots')}
      </NavLink>
      <NavLink to="/tablets" className={navLinkClass}>
        {t('nav.tablets')}
      </NavLink>
    </>
  )
}

export default function Layout() {
  const { user, signOut } = useAuth()
  const { t, i18n } = useTranslation()

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ja' ? 'en' : 'ja')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-30 bg-white border-b border-gray-200">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex h-14 md:h-16 items-center justify-between gap-2">
            <div className="flex items-center gap-3 min-w-0">
              <Forklift
                className="h-6 w-6 shrink-0"
                style={{ color: '#6366f1' }}
              />
              <span className="text-lg font-semibold text-gray-900 whitespace-nowrap truncate">
                {t('app.title')}
              </span>
              <nav className="hidden md:flex items-center gap-1 ml-4">
                <NavLinks />
              </nav>
            </div>
            <div className="flex items-center gap-1 md:gap-4 shrink-0">
              <span className="hidden lg:inline text-sm text-gray-600">
                {user?.email}
              </span>
              <button
                onClick={toggleLanguage}
                className="flex items-center gap-2 px-2 md:px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                title="Language"
              >
                <Languages className="w-4 h-4" />
                <span className="hidden sm:inline">
                  {i18n.language === 'ja' ? 'EN' : 'JA'}
                </span>
              </button>
              <button
                onClick={signOut}
                className="flex items-center gap-2 px-2 md:px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                title={t('common.signOut')}
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">{t('common.signOut')}</span>
              </button>
            </div>
          </div>
          {/* スマホ用ナビ（横スクロール可） */}
          <nav className="flex md:hidden items-center gap-1 pb-2 -mx-1 px-1 overflow-x-auto">
            <NavLinks />
          </nav>
        </div>
      </header>
      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  )
}
